import { FC } from 'react';
import { Box, Typography } from '@altermaind/web/ui';

type Props = {
  color: 'success' | 'error' | 'warning' | 'notReliable';
  label: string;
  noBadge?: boolean;
};

export const StatusBadge: FC<Props> = ({ color, label, noBadge = false }) => {
  return (
    <Box alignItems='flex-start' flexDirection='row' display='flex'>
      <Box alignItems='center' flexDirection='row' display='flex'>
        {!noBadge && (
          <Box mr='xxs' width='90'>
            <Box
              title={label}
              borderRadius='50%'
              width='xs'
              height='xs'
              borderColor={color !== 'notReliable' ? color : 'success'}
              bg={color !== 'notReliable' ? color : 'transparent'}
              border='1px solid'
            />{' '}
          </Box>
        )}
        <Typography
          color={noBadge && color !== 'notReliable' ? color : undefined}
          variant='p2/light'
        >
          {label}
        </Typography>
      </Box>
    </Box>
  );
};
